import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Logo } from "@root/components/atoms/Logo/Component";
import { useAppContext } from "@root/global/context";
import type {
  ProgressStateAdm,
  ProgressStateDtg,
  ProgressStateGbd,
  ProgressStateVda,
} from "@root/misc/constants";
import { checkTitle } from "@root/misc/helpers";
import { getTranslatedText } from "@root/utils/ui";
import * as React from "react";
import { useLocation, useParams } from "react-router-dom";
import CurrentStep from "../CurrentStep/Component";
import style from "./style.module.css";

export default function HeaderAppBar(): JSX.Element {
  const location = useLocation();
  const { variant } = useParams();
  const {
    pageTitle,
    setPageTitle,
    progressStateAdm,
    progressStateGbd,
    progressStateDtg,
    progressStateVda,
  } = useAppContext();

  React.useEffect(() => {
    const checkVariant = (value: string): string => {
      switch (value) {
        case "home":
          return ` - ${getTranslatedText("location.home")}`;
        default:
          return "";
      }
    };

    const newPageTitle = `${checkTitle(location.pathname)}${checkVariant(variant ?? "")}`;
    setPageTitle(newPageTitle);
  }, [location, variant, setPageTitle]);

  // For each new test or variant that has a different amount of steps, this should be extended.
  const returnTestType = (value: string): string => {
    switch (true) {
      case value.startsWith("/gbd"):
        return "gbd";
      case value.startsWith("/adm"):
        return "adm";
      case value.startsWith("/dtg/home"):
        return "dtg-home";
      case value.startsWith("/dtg"):
        return "dtg";
      case value.startsWith("/vda"):
        return "vda";
      default:
        return "Dit zou je niet moeten zien.";
    }
  };

  // For each new test, this should be extended.
  const returnProgress = (
    value: string,
  ): ProgressStateGbd | ProgressStateAdm | ProgressStateDtg | ProgressStateVda => {
    switch (true) {
      case value.startsWith("/gbd"):
        return progressStateGbd;
      case value.startsWith("/adm"):
        return progressStateAdm;
      case value.startsWith("/vda"):
        return progressStateVda;
      // case value.startsWith("/dtg"):
      default:
        return progressStateDtg;
    }
  };

  return (
    <Box className={style.header} sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        variant="outlined"
        elevation={0}
        sx={{
          backgroundColor: "var(--color-neutral-100a70)",
          backdropFilter: "blur(24px)",
          color: "var(--color-brand-primary-500)",
          border: 0,
        }}
      >
        <Toolbar>
          {!location.pathname.startsWith("/introduction") && (
            <Logo variant={returnTestType(location.pathname)} />
          )}
          <Typography
            variant="h3"
            noWrap
            component="div"
            sx={{ display: { xs: "none", sm: "block" }, width: "25%" }}
          >
            {pageTitle}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />

          <div
            style={{
              display: "flex",
              zIndex: 99999,
              position: "absolute",
              width: "100%",
            }}
          >
            <img
              height="46px"
              width="107px"
              src="/human-company-logo.svg"
              alt="Logo Human Company"
              style={{
                margin: "0 auto",
              }}
            />
          </div>

          {!location.pathname.startsWith("/introduction") && (
            <CurrentStep
              testType={returnTestType(location.pathname)}
              value={returnProgress(location.pathname)}
            />
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
